import { lazy } from "react";
import type { RouteObject } from "react-router-dom";
import AdminModule from "../layouts/index";
import type { AcMenuItem } from "../types/acMenu";
import { toAcMenuRoutePath } from "../acMenu/filterAcMenus";
import { STATIC_MODULE_ROUTE_PATHS } from "../constants/acMenu";

const DynamicModulePage = lazy(() => import("../pages/dynamicModule"));

/**
 * Build iframe RouteObjects for matched AC menus.
 * SPA route = `/${module.name}` (API `path` is iframe URL suffix only).
 */
export function buildDynamicIframeRoutes(
  modules: AcMenuItem[]
): RouteObject[] {
  const seen = new Set<string>();
  const routes: RouteObject[] = [];

  for (const mod of modules) {
    const routePath = toAcMenuRoutePath(mod.name);
    const subDomain = (mod.subDomainName || "").trim();
    if (!routePath || !subDomain) continue;
    if (STATIC_MODULE_ROUTE_PATHS.has(routePath)) continue;
    if (seen.has(routePath)) continue;
    seen.add(routePath);

    routes.push({
      path: routePath,
      element: <AdminModule />,
      children: [
        {
          path: "",
          element: <DynamicModulePage />,
        },
      ],
    });
  }

  return routes;
}
